import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { delegate } from 'utils-decorators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CobrancaData } from '../data/pagamento/cobranca.data';
import { instanceToPlain } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class PagamentoService {

  constructor(
    protected readonly http: HttpClient = inject(HttpClient)
  ) { }

  @delegate()
  async consultarPagamento(token: string) {

    const url = `${environment.urlBaseAPI}auth/cobrancas`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `${token}`
    });
    let consulta: any = await firstValueFrom(this.http.get<any>(url, { headers }));
    return consulta;
  }

  @delegate()
  async realizarPagamento(body: CobrancaData, token: string) {

    const url = `${environment.urlBaseAPI}auth/cobrancas/cartoes-credito`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `${token}`
    });

    const resp = await firstValueFrom(
      this.http.post<any>(url, instanceToPlain(body), { headers })
    );

    return resp;

  }

  @delegate()
  async consultaParcelas(body: any, token: string) {
    let params = new HttpParams();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `${token}`,
      'X-Amz-Date': new Date().toISOString(),
    });

    for (const [key, value] of Object.entries(body)) {
      if (value !== null && value !== ' ' && value !== undefined)
        params = params.append(`${key}`, `${value}`);
    }
    const url = `${environment.urlBaseAPI}auth/cobrancas/cartoes-credito/parcelas`;
    const lista = await firstValueFrom(this.http.get<any>(url, { params, headers }));

    return lista
  }


}
